import { getAuth,multiFactor ,PhoneMultiFactorGenerator,createUserWithEmailAndPassword,FacebookAuthProvider,GoogleAuthProvider ,signInWithPopup , RecaptchaVerifier, signInWithPhoneNumber, signInWithEmailAndPassword,signOut,PhoneAuthProvider } from "firebase/auth";
import React, { useEffect, useState } from 'react';
import { useNavigate,useLocation } from "react-router-dom";
import axios from "axios";
import { ErrorText, GreenText, PrimaryText, PurpleText, SecondaryText } from "../../components/mui/Typography";
import { PurpleButton } from "../../components/mui/Buttons";
import { AutoCompleteInput, PhoneInput, TextInput } from "../../components/mui/Inputs";
import '../../styling/profile.css'
import MuiPhoneNumber from 'material-ui-phone-number';
import { Autocomplete, Checkbox, FormControlLabel, IconButton, InputAdornment } from "@mui/material";
import { Error, Visibility, VisibilityOff } from "@mui/icons-material";
import VerifyPhoneNumber from "../verifyPhoneNumber";
import BackBar from "../../components/BackBar";
import Moment from 'moment';

export default function UpdateProfileDetails() {

    const baseURL = "https://us-central1-travel-fitness-pass.cloudfunctions.net/";

    const user = JSON.parse(localStorage.getItem("user"))
    console.log("USER",user)

    const [nameText,setNameText] = useState(user.personalDetails.firstName)
    const [surnameText,setSurnameText] = useState(user.personalDetails.surname)

    const [genderText,setGenderText] = useState(user.personalDetails.gender)

    const [dobText,setDOBText] = useState("")
    const [countryText,setCountryText] = useState(user.personalDetails.country)

    const [phoneText,setPhoneText] = useState("")

    const [twoFactor,setTwoFactor] = useState(false)
    const [showVerify,setShowVerify] = useState(false)

    const [successText,setSuccessText] = useState("")
    const [errorText,setErrorText] = useState("")

    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);
    
    

    const location = useLocation();
    const navigate = useNavigate();

    let dob = user.personalDetails.dob
    let dobDate = new Date(dob)
    let dateStr = Moment(dobDate).format('yyyy-MM-DD')
    if(dobText === ""){
        setDOBText(dateStr)
    }


    const submitClicked = () => {


        setSuccessText("")
        setErrorText("")

        // checkFields()
        updateAccountDB()

    }


    const updateAccountDB = () => {

        


        const uid = user.uid
        
        axios.post(baseURL+'updateUserAccount',{
        
            uid:uid,

            firstName:nameText,
            surname:surnameText,
            email:user.email,
            gender:genderText,
            dob:dobText,
            country:countryText,
            phone:phoneText

        
        }).then((response) => {

            setSuccessText("Details updated successfully")

            let resVar = response.data
            

            let pd = user.personalDetails
            console.log("Response", resVar,user,pd)

            pd.firstName = nameText
            pd.surname = surnameText
            
            pd.gender = genderText
            pd.country = countryText
            
            pd.dob = new Date(dobText)
            pd.phone = phoneText

            localStorage.setItem("user",JSON.stringify(user))

        })
    }

    

    
    const genderOptions = ['Male','Female','Other']
    const countryOptions = [ "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas (the)", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia (Plurinational State of)", "Bonaire, Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory (the)", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Cayman Islands (the)", "Central African Republic (the)", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands (the)", "Colombia", "Comoros (the)", "Congo (the Democratic Republic of the)", "Congo (the)", "Cook Islands (the)", "Costa Rica", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czechia", "Côte d'Ivoire", "Denmark", "Djibouti", "Dominica", "Dominican Republic (the)", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Falkland Islands (the) [Malvinas]", "Faroe Islands (the)", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories (the)", "Gabon", "Gambia (the)", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See (the)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea (the Democratic People's Republic of)", "Korea (the Republic of)", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic (the)", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands (the)", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia (Federated States of)", "Moldova (the Republic of)", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands (the)", "New Caledonia", "New Zealand", "Nicaragua", "Niger (the)", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands (the)", "Norway", "Oman", "Pakistan", "Palau", "Palestine, State of", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines (the)", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Republic of North Macedonia", "Romania", "Russian Federation (the)", "Rwanda", "Réunion", "Saint Barthélemy", "Saint Helena, Ascension and Tristan da Cunha", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin (French part)", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten (Dutch part)", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "Sudan (the)", "Suriname", "Svalbard and Jan Mayen", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands (the)", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates (the)", "United Kingdom of Great Britain and Northern Ireland (the)", "United States Minor Outlying Islands (the)", "United States of America (the)", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela (Bolivarian Republic of)", "Viet Nam", "Virgin Islands (British)", "Virgin Islands (U.S.)", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe", "Åland Islands" ];


    const phoneChange = (e) => {
        console.log("PONE CHANGED ", e)
    }

    const backClicked = () => {
        navigate("../profile", {  });
    }


    return(
        <div className="registerScreen">
            <BackBar clicked={backClicked}/>

            
            <div className="fullScreen">
                <div className="container">
                    <div className="registerMainSection">

                        <div className="registerInputView">

                        <div className="loginHeaders">
                            <PrimaryText variant="h3">PROFILE DETAILS</PrimaryText>
                            <SecondaryText variant="subtitle">Keep your personal information up to date</SecondaryText>
                        </div>


                        <div className="registerInputsSection">
                            <div className="registerInputColumn">
                                <TextInput variant="outlined" label="First Name*"
                                value={nameText} onChange={(e) => setNameText(e.target.value)}/>

                                <TextInput variant="outlined" label="Surname*"
                                value={surnameText} onChange={(e) => setSurnameText(e.target.value)}/>

                                <TextInput type="date"  variant="outlined" label="Date of birth" required
                                value={dobText} onChange={(e) => setDOBText(e.target.value)}/>
                               

                            </div>
                            <div className="registerInputColumn">
                                <Autocomplete disablePortal options={genderOptions} defaultValue={user.personalDetails.gender} renderInput={(params)=><TextInput {...params} variant="outlined" label="Gender" value={genderText} />} onChange={(e) => setGenderText(e.target.textContent)}/>
                                
                                <Autocomplete disablePortal options={countryOptions} defaultValue={user.personalDetails.country}  renderInput={(params)=><TextInput {...params} variant="outlined" label="Country" value={countryText} />} onChange={(e) => setCountryText(e.target.textContent)}/>

                                <PhoneInput 
                                    defaultCountry={'ie'} 
                                    variant="outlined" 
                                    label="Phone number"
                                    
                                    error={phoneText.length<13 && phoneText.length>0}
                                    helperText={phoneText.length<13 && phoneText.length>0?"Phone number not long enough":""}
                                    value ={phoneText} onChange={(e) => setPhoneText(e)}
                                    InputProps={{ // <-- This is where the toggle button is added.
                                        endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton>
                                                {(phoneText.length<13 && phoneText.length>0) && <Error className="inputErrorIcon"/>}
                                            </IconButton>
                                        </InputAdornment>
                                        )
                                    }}
                                />

                                <FormControlLabel control={<Checkbox checked={twoFactor} onChange ={(e) => setTwoFactor(e.target.checked)}/>} label="Use 2 factor verification" />
                            </div>
                            
                        </div>

                        <div className="updateProfileSubmitSection">
                            

                            <PurpleButton variant="contained" size="medium" onClick={submitClicked}
                            disabled={nameText==="" || surnameText===""  || genderText===""  || dobText===""}>
                                SAVE CHANGES</PurpleButton>

                        </div>

                        {errorText!=="" &&<ErrorText variant="body">{errorText}</ErrorText>}
                        {successText!=="" &&<GreenText variant="body">{successText}</GreenText>}

                        </div>


                        {showVerify && <div className="phoneVerifyScreen">
                                <VerifyPhoneNumber phoneNumber={phoneText} twoFactor={twoFactor}/>
                        </div>}

                    </div>
                </div>
            </div>

            

        </div>

        
    )
}